import mixpanel from "mixpanel-browser"
import { PAYMENT_EVENTS } from "."

export interface LivesUsedProps {
  features: string[]
  email: string
  registrationDate: string
  lastLifeUsage: string
  daysBetween: number
}

export function livesUsed(props: LivesUsedProps) {
  mixpanel.track(PAYMENT_EVENTS.LIVES_USED, props)
}
